import { TMeetingRoom } from "apis/meetings/meeting-room";
import React, { useEffect } from "react";
import UI from "@mile-meeting/mile-ui";
import { Container } from "./MeetingRoomFilter.styles";
import MeetingRoomFilterDropdown from "./MeetingRoomFilterDropdown/MeetingRoomFilterDropdown";

type MeetingRoomFilterProps = {
  meetingRoomList: TMeetingRoom[];
  value?: TMeetingRoom[];
  onChange?: (value: TMeetingRoom[]) => void;
  onClick?: () => void;
};

const MeetingRoomFilter: React.FC<MeetingRoomFilterProps> = ({ meetingRoomList, onChange, onClick, value = [] }) => {
  const [openMeetingRoomDropdown, setOpenMeetingRoomDropdown] = React.useState<boolean>(false);
  const ref = React.useRef<HTMLDivElement>(null);

  const handleRemoveFilter = () => {
    onChange?.([]);
  };

  const filterInputValue = value.map((item) => item.name).join(" | ");

  useEffect(() => {
    const handler = (event: any) => {
      if (openMeetingRoomDropdown && ref.current && !ref.current.contains(event.target)) {
        setOpenMeetingRoomDropdown?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [openMeetingRoomDropdown]);

  return (
    <Container onClick={onClick} onFocus={() => setOpenMeetingRoomDropdown(true)}>
      <UI.InputGroup.TextField
        width={200}
        prefixIcon="meetingRoom2"
        showPrefixIcon
        placeholder="회의실 이름"
        size="small"
        value={filterInputValue}
        disabledFocus
        suffixIcon="removeCircle"
        showSuffixIcon={value.length > 0}
        onClickSuffixIcon={handleRemoveFilter}
      />
      <MeetingRoomFilterDropdown
        ref={ref}
        meetingRoomList={meetingRoomList}
        open={openMeetingRoomDropdown}
        value={value}
        onChange={(value) => {
          onChange?.(value);
        }}
      />
    </Container>
  );
};

export default React.memo(MeetingRoomFilter);
